import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  employmentRelationShipLength: 0,
  employmentRelationShip: [],
}

export default function employmentRelationShipFuncionalReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_EMPLOYMENT_RELATIONSHIP:
      return {...state, loading: action.payload}
    case actions.GET_EMPLOYMENT_RELATIONSHIP:
      return {...state, employmentRelationShip: action.payload.employmentRelationShip, employmentRelationShipLength: action.payload.employmentRelationShipLength}
    default:
      return {...state};
  }
}